import React from "react";
import top from "../../assets/images/brand/talsolution-mark-top.png";
import bottom from "../../assets/images/brand/talsolution-mark-bottom.png";
import "./brand.scss";

/** Animated TalSolution "S": the blue and lime halves slide together and apart. */
export default function BrandLoader({ size = 56, className = "" }) {
  return (
    <span className={`ts-loader ${className}`} style={{ width: size, height: size }} role="status" aria-label="Loading">
      <img src={top} alt="" className="ts-loader__half ts-loader__half--top" draggable={false} />
      <img src={bottom} alt="" className="ts-loader__half ts-loader__half--bottom" draggable={false} />
    </span>
  );
}
